var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "zip-range-container" },
    [
      _c(
        "el-input",
        {
          attrs: {
            readonly: "",
            placeholder: _vm.$t("CenterForSorting.pleaseInput"),
            size: "small",
          },
          nativeOn: {
            click: function ($event) {
              return _vm.openDialog($event)
            },
          },
          model: {
            value: _vm.displayValue,
            callback: function ($$v) {
              _vm.displayValue = $$v
            },
            expression: "displayValue",
          },
        },
        [
          _c("i", {
            staticClass: "el-input__icon el-icon-edit-outline pointer",
            attrs: { slot: "suffix" },
            on: {
              click: function ($event) {
                $event.stopPropagation()
                return _vm.openDialog($event)
              },
            },
            slot: "suffix",
          }),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("CenterForSorting.zipRangeConfig"),
            visible: _vm.dialogVisible,
            width: "600px",
            "append-to-body": "",
            "close-on-click-modal": false,
            "custom-class": "zip-range-dialog",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "zip-range-editor" },
            [
              _vm.localList.length === 0
                ? _c("div", { staticClass: "empty-tip" }, [
                    _vm._v(
                      " " + _vm._s(_vm.$t("CenterForSorting.noData")) + " "
                    ),
                  ])
                : _vm._e(),
              _vm._l(_vm.localList, function (item, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "zip-item-row" },
                  [
                    _c(
                      "el-row",
                      { attrs: { gutter: 10, type: "flex", align: "middle" } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 10 } },
                          [
                            _c("el-input", {
                              attrs: {
                                placeholder: _vm.$t(
                                  "CenterForSorting.startZip"
                                ),
                                maxlength: "8",
                                clearable: "",
                                disabled: _vm.disabled,
                              },
                              on: {
                                input: function ($event) {
                                  return _vm.validateItem(item)
                                },
                              },
                              model: {
                                value: item.start,
                                callback: function ($$v) {
                                  _vm.$set(item, "start", $$v)
                                },
                                expression: "item.start",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          {
                            staticStyle: { "text-align": "center" },
                            attrs: { span: 2 },
                          },
                          [_vm._v("~")]
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 10 } },
                          [
                            _c("el-input", {
                              attrs: {
                                placeholder: _vm.$t("CenterForSorting.endZip"),
                                maxlength: "8",
                                clearable: "",
                                disabled: _vm.disabled,
                              },
                              on: {
                                input: function ($event) {
                                  return _vm.validateItem(item)
                                },
                              },
                              model: {
                                value: item.end,
                                callback: function ($$v) {
                                  _vm.$set(item, "end", $$v)
                                },
                                expression: "item.end",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 2 } },
                          [
                            _c("el-button", {
                              attrs: {
                                type: "danger",
                                icon: "el-icon-minus",
                                circle: "",
                                size: "mini",
                                disabled: _vm.disabled,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.removeItem(index)
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    item.error
                      ? _c("div", { staticClass: "error-msg" }, [
                          _vm._v(_vm._s(item.error)),
                        ])
                      : _vm._e(),
                  ],
                  1
                )
              }),
              _c(
                "div",
                { staticClass: "add-btn-wrapper" },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        type: "primary",
                        plain: "",
                        icon: "el-icon-plus",
                        size: "small",
                        disabled: _vm.disabled,
                      },
                      on: { click: _vm.addItem },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("CenterForSorting.addZipRange")) +
                          " "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm.hasValidRanges
                ? _c("div", { staticClass: "visualization-container" }, [
                    _c("div", { staticClass: "chart-header" }, [
                      _c("div", { staticClass: "chart-title" }, [
                        _vm._v(
                          _vm._s(_vm.$t("CenterForSorting.zipDistribution"))
                        ),
                      ]),
                      _c("div", { staticClass: "chart-note" }, [
                        _vm._v(
                          _vm._s(_vm.$t("CenterForSorting.zipSchematicHint"))
                        ),
                      ]),
                    ]),
                    _c(
                      "div",
                      { staticClass: "chart-wrapper" },
                      [
                        _c(
                          "svg",
                          {
                            ref: "chartSvg",
                            staticClass: "zip-chart",
                            attrs: {
                              viewBox:
                                "0 0 " + _vm.svgWidth + " " + _vm.svgHeight,
                              preserveAspectRatio: "none",
                            },
                          },
                          [
                            _c("line", {
                              attrs: {
                                x1: _vm.padding,
                                y1: _vm.axisY,
                                x2: _vm.svgWidth - _vm.padding,
                                y2: _vm.axisY,
                                stroke: "#E4E7ED",
                                "stroke-width": "2",
                              },
                            }),
                            _vm._l(_vm.processedSegments, function (segment) {
                              return _c(
                                "g",
                                {
                                  key:
                                    "seg-" + segment.start + "-" + segment.end,
                                },
                                [
                                  _c(
                                    "line",
                                    _vm._b(
                                      {
                                        staticClass: "chart-segment",
                                        attrs: {
                                          y1: _vm.axisY,
                                          y2: _vm.axisY,
                                          stroke: segment.isOverlap
                                            ? "#F56C6C"
                                            : "#67C23A",
                                          "stroke-width":
                                            _vm.segmentStrokeWidth,
                                          "stroke-linecap": "round",
                                        },
                                      },
                                      "line",
                                      _vm.getSegmentCoords(segment),
                                      false
                                    )
                                  ),
                                ]
                              )
                            }),
                            _vm._l(_vm.processedPoints, function (point, idx) {
                              return _c("g", { key: "pt-" + idx }, [
                                _c("circle", {
                                  staticClass: "chart-point",
                                  attrs: {
                                    cx: _vm.getVisualX(point.value),
                                    cy: _vm.axisY,
                                    r: _vm.pointRadius,
                                    fill: point.isOverlap
                                      ? "#F56C6C"
                                      : "#67C23A",
                                    stroke: "#fff",
                                    "stroke-width": "2",
                                  },
                                  on: {
                                    mouseenter: function ($event) {
                                      return _vm.showTooltip(
                                        $event,
                                        point.value
                                      )
                                    },
                                    mouseleave: _vm.hideTooltip,
                                  },
                                }),
                              ])
                            }),
                          ],
                          2
                        ),
                        _c(
                          "transition",
                          { attrs: { name: "el-fade-in-linear" } },
                          [
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.tooltip.visible,
                                    expression: "tooltip.visible",
                                  },
                                ],
                                staticClass: "chart-tooltip",
                                style: {
                                  left: _vm.tooltip.x + "px",
                                  top: _vm.tooltip.y + "px",
                                },
                              },
                              [
                                _c("div", { staticClass: "tooltip-content" }, [
                                  _c("span", { staticClass: "tooltip-label" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("CenterForSorting.zipCode")
                                      ) + ":"
                                    ),
                                  ]),
                                  _c("span", { staticClass: "tooltip-value" }, [
                                    _vm._v(_vm._s(_vm.tooltip.content)),
                                  ]),
                                ]),
                                _c("div", { staticClass: "tooltip-arrow" }),
                              ]
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
            ],
            2
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("CenterForSorting.cancel")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", disabled: _vm.disabled },
                  on: { click: _vm.handleConfirm },
                },
                [_vm._v(_vm._s(_vm.$t("CenterForSorting.confirm")))]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }